// THIS FILE IS AUTOGENERATED. DO NOT EDIT
/* eslint-disable */
/* tslint:disable */
import * as router from './router'
export { router }